import "./css/CheckupSurveyWidget.css"

interface Props {
    onClick: () => void,
}

const CheckupSurveyWidget: React.FC<Props> = ({
    onClick,
}) => {
    return (
        <div className={`checkup-survey-widget-container`}>
            <div className={`checkup-survey-widget-left-element-container`}>
                <div className={`checkup-survey-widget-widget-left-element-internal-container`}>
                    <div className="checkup-survey-widget-heading">Check-up</div>
                    <div className="checkup-survey-widget-copy"><span className="w700">Hai ricevuto il tuo piano da due settimane.</span><br></br>
                    È il momento di condividere come sta andando rispondendo a qualche domanda in meno di due minuti!
                    </div>
                    <button
                        className={`checkup-survey-widget-answer-button primary_action_color_background`}
                        onClick={onClick}
                    >
                        Rispondi
                    </button>
                </div>
            </div>
            <div className={`checkup-survey-widget-right-element-container`} />
        </div>
    )
}

export default CheckupSurveyWidget
